// Import the RTK Query methods from the React-specific entry point
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
// import {graphqlRequestBaseQuery} from '@rtk-query/graphql-request-base-query'
// import { gql } from 'graphql-request'
import { Auth } from 'aws-amplify'

import { GetTeachersInput, GetSchoolsInput, GetClassroomsInput, GetStudentsInput, GetEPathsInput, GetUsersInput, GetUserInput,
        AddTeacherInput, AddStudentInput, AddClassroomInput, AddClassroomTeacherInput, AddStudentClassroomInput, GetScoreInput, GetBenchmarkInput, GetBenchmarksInput,
        AddUserInput, GetContentsInput, GetContentInput, GetAssessmentInput, GetAssessmentsInput, GetStudentAssessmentsInput, AddAssessmentInput, 
        UpdateAssessmentInput,  GetAssessmentByIdInput, AddSchoolInput, GetSchoolListInput, AddTeacherSchoolInput, UpdateStudentInput } from 'API';
import type { Teacher, School, SchoolList, Classroom, Student, EPath, User, Content, Score, Benchmark, Assessment, AssessmentContent, AssessmentPart, AssessmentData, } from 'utils/types'
import { getStudents, getTeachers, getSchools, getClassrooms, getEPaths, getUsers, getUser, getContents, getSchoolList,
        getContent, getAssessment, getBenchmark, getBenchmarks, getAssessments, getAssessmentById, getStudentAssessments } from 'graphql/queries'
import { addUser, addTeacher, addSchool, addStudent, addClassroom, addClassroomTeacher, 
        addStudentClassroom, addAssessment, updateAssessment,addTeacherSchool, updateStudent  } from 'graphql/mutations'

// const endpoint = 'https://hptxv7qhxjbplc5ri2bevsmb74.appsync-api.us-west-2.amazonaws.com/graphql' // not query
//const endpoint = 'https://dboebqztkzajlncguoirf35yv4.appsync-api.us-west-2.amazonaws.com/graphql' // not query 20Jun24 - Dev account
const endpoint = process.env.REACT_APP_API_URL
//const endpoint = 'https://vkz6oonzpfb4de4dd7prkllkl4.appsync-api.us-west-2.amazonaws.com/graphql' // staging account - 15Oct24
// const endpoint = 'https://dev.api.esteam.ai/graphql'
//console.log('REACT_APP_TEST_VARIABLE', process.env.REACT_APP_TEST_VARIABLE);
const baseTeacherQuery = `query GET_TEACHERS($getTeachersInput: GetTeachersInput!) {
    getTeachers(getTeachersInput: $getTeachersInput) {
      data {
        PK
        SK
        id
        code
        firstName
        lastName
        email
        classes
        status
        school
        createdAt
        updatedAt
      }
      nextToken
    }
  }`
 // {id: "9UTd5Ei6MC0etvtcAQ9uw"}
const  myQuery = `  query GET_ASSESSMENTBYID($getAssessmentByIdInput: GetAssessmentByIdInput!) {
    getAssessmentById(getAssessmentByIdInput: $getAssessmentByIdInput) {
      data {
        assessments {
          PK
          SK
          id
          pathName
          pathId
          studentId
          teacherCode
          schoolCode
          asmtStatus
          elementCount
          elements {
            id
            name
            status
            scoreId
            contentId
            updatedAt
          }
          createdAt
          updatedAt
          status
        }
        contents {
          PK
          SK
          id
          name
          contentId
          contentIndex
          assessmentId
          studentId
          teacherCode
          schoolCode
          asmtStatus
          partsCount
          parts {
            id
            name
            status
            scoreId
            partId
          }
          contentType
          createdAt
          updatedAt
          status
        }
        parts {
          PK
          SK
          id
          assessmentId
          assessmentContentId
          audioPath
          bucket
          enabled
          testErrors
          level
          metricsJson {
            diffs_processed {
              difftype
              diffstring
            }
            insertions
            substitutions
            deletions
            processed_transcript
            editops {
              editType
              editsrc
              editdst
            }
            phonetic_error_word_idxs
            text_error_idxs
            nr_words
            nr_word_errors
            diffs {
              difftype
              diffstring
            }
            char2word
            wer
          }
          nrWords
          nrWordsErrors
          phoneticGndTruth
          phonetics
          prediction
          contentText
          scriptText
          phonemeText
          createdAt
          updatedAt
          status
        }
        scores {
          id
          scoreType
          assessmentId
          componentId
          studentId
          totalItems
          correct
          errors
          data
          duration
          contentType
          benchmarkId
          benchmarkVersion
          status
          updatedAt
        }
      }
      status
    }
  }
  `

// Define our single API slice object
export const api = createApi({
    // The cache reducer expects to be added at `state.api` (already default - this is optional)
    reducerPath: 'api',
    // All of our requests will have URLs starting with '/fakeApi'
    baseQuery: fetchBaseQuery({        
        baseUrl: endpoint,
        prepareHeaders: async (headers, query) => {
            let res = await Auth.currentSession()
            let accessToken = res.getAccessToken()
            let jwt = accessToken.getJwtToken()
            console.log(`Headers Jwt: ${jwt}`)
            headers.set('authorization', jwt)
            headers.set('content-type', 'application/json')
           return headers
        }
    }),
    tagTypes: ['Teacher', 'School', 'SchoolList', 'Classroom', 'Student', 'EPath', 'User', 'Content', 'Assessment', 'Score', 'Benchmark'],
    // The "endpoints" represent operations and requests for this server
    endpoints: builder => ({
      // The `getPosts` endpoint is a "query" operation that returns data
        getTeachers: builder.query<
                [Teacher], {getTeachersInput: GetTeachersInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getTeachersInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getTeachers,
                    "variables": {getTeachersInput: getTeachersInput}
                },
             }),
             providesTags: ['Teacher'],
             transformResponse: (response: {data: {getTeachers: {data: [Teacher], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getTeachers.data as [Teacher]},
        }),
        getSchools: builder.query<
                [School], {getSchoolsInput: GetSchoolsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getSchoolsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getSchools,
                    "variables": {getSchoolsInput: getSchoolsInput}
                },
             }),
             providesTags: ['School'],
             transformResponse: (response: {data: {getSchools: {data: [School], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getSchools.data as [School]},
        }),
        getSchoolList: builder.query<
                [SchoolList], {getSchoolListInput: GetSchoolListInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getSchoolListInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getSchoolList,
                    "variables": {getSchoolListInput: getSchoolListInput}
                },
             }),
             providesTags: ['SchoolList'],
             transformResponse: (response: {data: {getSchoolList: {data: [SchoolList], nextToken: string}}} ) => {
                console.log("SchoolList Response: ",response)
                return response.data.getSchoolList.data as [SchoolList]},
        }),
        getStudents: builder.query<
                [Student], {getStudentsInput: GetStudentsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getStudentsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getStudents,
                    "variables": {getStudentsInput: getStudentsInput}
                },
             }),
             providesTags: ['Student'],
             transformResponse: (response: {data: {getStudents: {data: [Student], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getStudents.data as [Student]},
        }),
        getClassrooms: builder.query<
                [Classroom], {getClassroomsInput: GetClassroomsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getClassroomsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getClassrooms,
                    "variables": {getClassroomsInput: getClassroomsInput}
                },
             }),
             providesTags: ['Classroom'],
             transformResponse: (response: {data: {getClassrooms: {data: [Classroom], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getClassrooms.data as [Classroom]},
        }),
        getPaths: builder.query<
                [EPath], {getEPathsInput: GetEPathsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getEPathsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getEPaths,
                    "variables": {getEPathsInput: getEPathsInput}
                },
             }),
             providesTags: ['EPath'],
             transformResponse: (response: {data: {getEPaths: {data: [EPath], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getEPaths.data as [EPath]},
        }),
        getContents: builder.query<
        [Content], {getContentsInput: GetContentsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getContentsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getContents,
                    "variables": {getContentsInput: getContentsInput}
                },
            }),
            providesTags: ['Content'],
            transformResponse: (response: {data: {getContents: {data: [Content], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getContents.data as [Content]},
        }),
        getContent: builder.query<
        Content, {getContentInput: GetContentInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getContentInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getContent,
                    "variables": {getContentInput: getContentInput}
                },
            }),
            providesTags: ['Content'],
            transformResponse: (response: {data: {getContent: {data: Content}}} ) => {
                console.log("Response: ",response)
                return response.data.getContent.data as Content},
        }),
        getUsers: builder.query<
                [User], {getUsersInput: GetUsersInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getUsersInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getUsers,
                    "variables": {getUsersInput: getUsersInput}
                },
             }),
             providesTags: ['User'],
             transformResponse: (response: {data: {getUsers: {data: [User], nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.getUsers.data as [User]},
        }),
        getUser: builder.query<
                User, {getUserInput: GetUserInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getUserInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getUser,
                    "variables": {getUserInput: getUserInput}
                },
             }),
             providesTags: ['User'],
             transformResponse: (response: {data: {getUser: {data: User}}} ) => {
                console.log("Get User Response: ",response, response.data.getUser.data)
                return response.data.getUser.data as User},
        }),
        getAssessment: builder.query<
                Assessment, {getAssessmentInput: GetAssessmentInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getAssessmentInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getAssessment,
                    "variables": {getAssessmentInput: getAssessmentInput}
                },
             }),
             providesTags: ['Assessment'],
             transformResponse: (response: {data: {getAssessment: {data: Assessment}}} ) => {
                console.log("Response: ",response)
                return response.data.getAssessment.data as Assessment},
        }),
        getAssessmentById: builder.query<
                AssessmentData[], {getAssessmentByIdInput: GetAssessmentByIdInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getAssessmentByIdInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getAssessmentById,
                    "variables": {getAssessmentByIdInput: getAssessmentByIdInput}
                },
            }),
            providesTags: ['Assessment'],
            transformResponse: (response: {data: {getAssessmentById: {data: AssessmentData[], status: string}}} ) => {
                console.log("ById Response: ",response)
                console.log("ById response parts :", response.data.getAssessmentById.data[0].parts)
                console.log("Response status: ",response.data.getAssessmentById.status)
                return response.data.getAssessmentById.data as AssessmentData[]},
        }),
        getBenchmark: builder.query<
                Benchmark, {getBenchmarkInput: GetBenchmarkInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getBenchmarkInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getBenchmark,
                    "variables": {getBenchmarkInput: getBenchmarkInput}
                },
             }),
             providesTags: ['Benchmark'],
             transformResponse: (response: {data: {getBenchmark: {data: Benchmark}}} ) => {
                console.log("**Benchmark Response: ",response)
                return response.data.getBenchmark.data as Benchmark},
        }),
        getBenchmarks: builder.query<
                [Benchmark], {getBenchmarksInput: {
                    ids: [string]
                }}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getBenchmarksInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getBenchmarks,
                    "variables": {getBenchmarksInput: getBenchmarksInput}
                },
            }),
            providesTags: ['Benchmark'],
            transformResponse: (response: {data: {getBenchmarks: {data: [Benchmark]}}} ) => {
                console.log("**Benchmarks Response: ",response)
                return response.data.getBenchmarks.data as [Benchmark]},
        }),
        getAssessments: builder.query<
                [Assessment], {getAssessmentsInput: GetAssessmentsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getAssessmentsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getAssessments,
                    "variables": {getAssessmentsInput: getAssessmentsInput}
                },
             }),
             providesTags: ['Assessment'],
             transformResponse: (response: {data: {getAssessments: {data: [Assessment], nextToken: string}}} ) => {
                console.log("GetAssessments Response: ",response)
                return response.data.getAssessments.data as [Assessment]},
        }),
        getStudentAssessments: builder.query<
                [Assessment], {getStudentAssessmentsInput: GetStudentAssessmentsInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({getStudentAssessmentsInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": getStudentAssessments,
                    "variables": {getStudentAssessmentsInput: getStudentAssessmentsInput}
                },
             }),
             providesTags: ['Assessment'],
             transformResponse: (response: {data: {getStudentAssessments: {data: [Assessment], nextToken: string}}} ) => {
                console.log("GetStudentAssessments Response: ",response)
                return response.data.getStudentAssessments.data as [Assessment]},
        }),


        addUser: builder.mutation<
                User, {addUserInput: AddUserInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({addUserInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": addUser,
                    "variables": {addUserInput: addUserInput}
                },
            }),
            invalidatesTags: ['User'],
    
            transformResponse: (response: {data: {addUser: {data: User, nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.addUser.data as User},
            }),
        addTeacher: builder.mutation<
                Teacher, {addTeacherInput: AddTeacherInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({addTeacherInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": addTeacher,
                    "variables": {addTeacherInput: addTeacherInput}
                },
            }),
            invalidatesTags: ['Teacher'],
    
            transformResponse: (response: {data: {addTeacher: {data: Teacher, nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.addTeacher.data as Teacher},
            }),
       addSchool: builder.mutation<
                School, {addSchoolInput: AddSchoolInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({addSchoolInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": addSchool,
                    "variables": {addSchoolInput: addSchoolInput}
                },
            }),
            invalidatesTags: ['School'],
    
            transformResponse: (response: {data: {addSchool: School}} ) => {
                console.log("Response: ",response)
                return response.data.addSchool as School},
            }),
        addStudent: builder.mutation<
                Student, {addStudentInput: AddStudentInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({addStudentInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": addStudent,
                    "variables": {addStudentInput: addStudentInput}
                },
            }),
            invalidatesTags: ['Student'],

            transformResponse: (response: {data: {addStudent: Student}} ) => {
                console.log("Response: ",response)
                return response.data.addStudent as Student},
            }),
        addClassroom: builder.mutation<
                Classroom, {addClassroomInput: AddClassroomInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({addClassroomInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": addClassroom,
                    "variables": {addClassroomInput: addClassroomInput}
                },
            }),
            invalidatesTags: ['Classroom'],
    
            transformResponse: (response: {data: {addClassroom: {data: Classroom, nextToken: string}}} ) => {
                console.log("Response: ",response)
                return response.data.addClassroom.data as Classroom},
            }),
        addClassroomTeacher: builder.mutation<
                Classroom, {addClassroomTeacherInput: AddClassroomTeacherInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({addClassroomTeacherInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": addClassroomTeacher,
                    "variables": {addClassroomTeacherInput: addClassroomTeacherInput}
                },
            }),
            invalidatesTags: ['Classroom', 'Teacher'],
    
            transformResponse: (response: {data: {addClassroomTeacher: Classroom}} ) => {
                console.log("AddClassroomTeacher Response: ",response, response.data.addClassroomTeacher)
                return response.data.addClassroomTeacher as Classroom},
            }),
        addTeacherSchool: builder.mutation<
                Teacher, {addTeacherSchoolInput: AddTeacherSchoolInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({addTeacherSchoolInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": addTeacherSchool,
                    "variables": {addTeacherSchoolInput: addTeacherSchoolInput}
                },
            }),
            invalidatesTags: ['User', 'Teacher'],

            transformResponse: (response: {data: {addTeacherSchool: Teacher}} ) => {
                console.log("AddTeacherSchool Response: ",response, response.data.addTeacherSchool)
                return response.data.addTeacherSchool as Teacher},
            }),
        addStudentClassroom: builder.mutation<
                Student, {addStudentClassroomInput: AddStudentClassroomInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({addStudentClassroomInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": addStudentClassroom,
                    "variables": {addStudentClassroomInput: addStudentClassroomInput}
                },
            }),
            invalidatesTags: ['Student','Classroom'],
    
            // transformResponse: (response: {data: {addStudentClassroom: {data: Student, nextToken: string}}} ) => {
            //     console.log("Response: ",response)
            //     return response.data.addStudentClassroom.data as Student},
            }),
       addAssessment: builder.mutation<
                Assessment, {addAssessmentInput: AddAssessmentInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({addAssessmentInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": addAssessment,
                    "variables": {addAssessmentInput: addAssessmentInput}
                },
            }),
            invalidatesTags: ['Assessment'],
    
            transformResponse: (response: {data: {addAssessment: {data: Assessment}}} ) => {
                console.log("Response: ",response)
                return response.data.addAssessment.data as Assessment},
            }),
        updateStudent: builder.mutation<
                Student, {updateStudentInput: UpdateStudentInput}
            >({
            // The URL for the request is the GraphQL endpoint
            query: ({updateStudentInput}) => ({
                url: '/',
                method: "POST",
                body: {
                    "query": updateStudent,
                    "variables": {updateStudentInput: updateStudentInput}
                },
            }),
            invalidatesTags: ['Student'],

            transformResponse: (response: {data: {updateStudent: Student}} ) => {
                console.log("Response: ",response)
                return response.data.updateStudent as Student},
            }),
     
        // invalidatesTags: ['Teacher']
    })
})
  
// Export the auto-generated hook for the  query endpoint
export const { 
  useGetTeachersQuery, 
  useGetSchoolsQuery,
  useGetSchoolListQuery,
  useGetStudentsQuery, 
  useGetClassroomsQuery,
  useAddUserMutation,
  useAddTeacherMutation,
  useAddSchoolMutation,
  useAddStudentMutation,
  useAddClassroomMutation,
  useAddClassroomTeacherMutation,
  useAddStudentClassroomMutation,
  useGetPathsQuery,
  useGetUsersQuery,
  useGetUserQuery,
  useGetContentsQuery,
  useGetAssessmentQuery,
  useGetAssessmentsQuery,
  useAddAssessmentMutation,
  useGetAssessmentByIdQuery,
  useGetStudentAssessmentsQuery,
  useAddTeacherSchoolMutation,
  useUpdateStudentMutation,
  useGetBenchmarkQuery,
  useGetBenchmarksQuery
  } = api

